import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileAreasOfSpecialisationEditorActions'

import { validiateChecklistField } from '../../../common/forms/validationFunctions'

const initialState = {
  loadingAreasOfSpecialisation: false,
  areasOfSpecialisationBeforeEditing: [],
  allAreasOfSpecialisation: [],
  isInvalid: {
    formIsValid: true,
    areasOfSpecialisation: {
      isInvalid: false,
      message: null
    }
  }
}

const minimumRequiredSelection = 1

export default function (state = initialState, action) {
  var newState = copyAreasOfSpecialisationPreferencesState(state)
  const { edit, fetch, set } = events
  switch (action.type) {
    case edit.start:
      newState.areasOfSpecialisationBeforeEditing = newState.profile.financialServicesOffered
      newState.areasOfSpecialisation.isInvalid.areasOfSpecialisation = validiateChecklistField(newState.profile.financialServicesOffered, minimumRequiredSelection)
      newState.areasOfSpecialisation.isInvalid.formIsValid = formIsValid(newState.areasOfSpecialisation.isInvalid)
      return newState
    case edit.cancel:
      newState.profile.financialServicesOffered = cloneDeep(newState.areasOfSpecialisationBeforeEditing)
      newState.areasOfSpecialisationBeforeEditing = []
      return newState
    case fetch.fetched:
      newState.areasOfSpecialisation.allAreasOfSpecialisation = action.payload
      return newState
    case set.selectionChanged:
      var foundIndex = null
      var selectedAreasOfSpecialisation = newState.profile.financialServicesOffered
      selectedAreasOfSpecialisation.forEach((areaOfSpecialisation, index) => {
        if (areaOfSpecialisation.financialServiceId === action.areaOfSpecialisation.financialServiceId) {
          foundIndex = index
        }
      })
      if (foundIndex !== null) {
        selectedAreasOfSpecialisation.splice(foundIndex, 1)
      } else {
        selectedAreasOfSpecialisation.push(action.areaOfSpecialisation)
      }
      newState.areasOfSpecialisation.isInvalid.areasOfSpecialisation = validiateChecklistField(selectedAreasOfSpecialisation, minimumRequiredSelection)
      newState.areasOfSpecialisation.isInvalid.formIsValid = formIsValid(newState.areasOfSpecialisation.isInvalid)
      newState.edited = true
      return newState
  }
  return state
}

function copyAreasOfSpecialisationPreferencesState (state) {
  var newState = cloneDeep(state)
  newState.profile = cloneDeep(state.profile)
  if (state.profile) {
    newState.profile.areasOfSpecialisation = cloneDeep(state.profile.areasOfSpecialisation)
  }
  return newState
}

function formIsValid (isInvalid) {
  return !isInvalid.areasOfSpecialisation.isInvalid
}
